
import Vue, { PropType } from 'vue'
import { DataTableHeader } from 'vuetify/types'

import HarvestsDataTable from '@/ui/components/harvests/HarvestsDataTable.vue'

import HarvestDetail from '@/ui/components/harvests/HarvestDetail.vue'
// import AddHarvest from '@/ui/components/AddHarvest.vue'
import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'

import Harvest from '@/models/Harvest'
import { id } from '@/types/models'
import Plant from '@/models/Plant'
import { formatNumber } from '@/helpers/formatters'

interface JDataTableHeader<T> extends DataTableHeader {
  total?: (items: Array<T>) => number | string
  totalIcon?: string
}

interface HarvestDate {
  date: string
  count: number
  quantity: number
  quality: number
  ripeness: number
  size: number
  traits: string[]
  ids: string[]
}

type ValueFunction<T> = (item: T) => number

const sum =
  <T extends unknown>(valFn: ValueFunction<T>) =>
  (items: Array<T>) =>
    items.reduce((prev: number, item: T) => prev + valFn(item), 0)

const wavg =
  <T extends unknown>(valFn: ValueFunction<T>, weightingFn: ValueFunction<T>) =>
  (items: Array<T>) =>
    items.reduce((prev: number, item: T) => prev + valFn(item), 0) /
    items.reduce((prev: number, item: T) => prev + weightingFn(item), 0)

// function sum<T>(valFn: ValueFunction<T>): (items: Array<T>) => number {
//   return (items: Array<T>): number => items.reduce((prev: number, item: T): number => prev + valFn(item), 0)
// }

// const formatter = <T extends unknown>(calcFn: (items: Array<T>) => number, formatFn: (val: number, ...args: Array<number | string>) => number | string) =>
const formatter =
  <T extends unknown>(
    calcFn: (items: Array<T>) => number,
    formatFn: (val: number) => number | string
  ) =>
  (items: Array<T>) =>
    formatFn(calcFn(items))

// calcFn: ValueFunction<T>, formatFn: (val: number, ...args?: Array<string | number>) => string | number) =>
//   (items: Array<T>) => formatFn(calcFn(item), args)

export default Vue.extend({
  components: {
    HarvestDetail,
    // AddHarvest,
    PlantAvatar,
    HarvestsDataTable,
  },
  props: {
    harvests: Array as PropType<Harvest[]>,

    harvestId: String,

    plantIds: {
      type: Array as PropType<Array<id>>,
      default: (): Array<id> => [],
    },

    sortBy: {
      type: [Array, String],
      default: 'date',
    },
    sortDesc: {
      type: [Array, Boolean],
      default: true,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },

    headers: {
      type: Array,
      default: function (): Array<JDataTableHeader<Harvest>> {
        return [
          // { text: '', value: 'images', sortable: false },

          {
            text: 'Date',
            value: 'date',
            align: 'center',
            total: () => 'Total',
          },
          {
            text: '#',
            value: 'count',
            width: 48,
            align: 'center',
            class: 'px-0 nowrap',
            total: formatter(
              sum<Harvest>((z) => z.quantity),
              (val: number) => formatNumber(val, 0)
            ),
          },
          {
            text: 'Qty',
            value: 'quantity',
            width: 48,
            align: 'end',
            class: 'pl-0 nowrap',
            total: formatter(
              sum<Harvest>((z) => z.quantity),
              (val: number) => formatNumber(val, 0)
            ),
          },
          // { text: 'Quality', value: 'quality', align: 'end', totalIcon: 'mdi-approximately-equal', total: wavg<Harvest>((z) => z.quality * z.quantity, (z) => z.quantity) },
          {
            text: 'Qual',
            value: 'quality',
            width: 48,
            align: 'end',
            class: 'pl-0 nowrap',
            total: formatter(
              wavg<Harvest>(
                (z) => z.quality * z.quantity,
                (z) => z.quantity
              ),
              (val: number) => formatNumber(val, 1)
            ),
          },
          // { text: 'Ripeness', value: 'ripeness', align: 'end', totalIcon: 'mdi-approximately-equal', total: wavg<Harvest>((z) => z.ripeness * z.quantity, (z) => z.quantity) },
          {
            text: 'Ripe',
            value: 'ripeness',
            width: 48,
            align: 'end',
            class: 'pl-0 nowrap',
            total: formatter(
              wavg<Harvest>(
                (z) => z.ripeness * z.quantity,
                (z) => z.quantity
              ),
              (val: number) => formatNumber(val, 1)
            ),
          },
          // { text: 'Size', value: 'size', align: 'end', totalIcon: 'mdi-approximately-equal', total: wavg<Harvest>((z) => z.size * z.quantity, (z) => z.quantity) },
          {
            text: 'Size',
            value: 'size',
            width: 48,
            align: 'end',
            class: 'pl-0 nowrap',
            total: formatter(
              wavg<Harvest>(
                (z) => z.size * z.quantity,
                (z) => z.quantity
              ),
              (val: number) => formatNumber(val, 1)
            ),
          },
          { text: 'Traits', value: 'traits' },

          { text: '', value: 'note', sortable: false },
          { text: '', value: 'data-table-expand' },
        ]
      },
    },
  },
  data: () => ({
    // dialogIds: undefined as Array<id> | undefined,
    // addDialogId: undefined as id | undefined,

    expanded: [],
  }),
  computed: {
    dialog(): boolean {
      // return !!this.dialogIds
      return !!this.harvestId
    },
    // addDialog(): boolean {
    //   return !!this.addDialogId
    // },
    // plantIds(): Array<id> {
    //   console.log(this.harvests)
    //   return [...new Set(this.harvests.map((h: Harvest) => h.plantId))]
    // },
    plants(): Array<Plant> {
      return this.$store.getters['gardens/plants/filter'](this.plantIds)
    },

    harvestDates(): Array<HarvestDate> {
      return this.harvests
        .reduce((acc, h) => {
          const i = acc.findIndex((z) => z.date === h.date)
          let d = acc[i]

          if (!d) {
            acc.push({
              date: h.date,
              count: 1,
              quantity: h.quantity,
              quality: h.quality * h.quantity,
              ripeness: h.ripeness * h.quantity,
              size: h.size * h.quantity,
              traits: h.traits,
              ids: [h.id],
            })
          } else {
            d = {
              date: d.date,
              count: d.count + 1,
              quantity: d.quantity + h.quantity,
              quality: d.quality + h.quality * h.quantity,
              ripeness: d.quality + h.ripeness * h.quantity,
              size: d.quality + h.size * h.quantity,
              traits: [...new Set([...d.traits, ...h.traits])],
              ids: [...d.ids, ...[h.id]],
            }

            this.$set(acc, i, d)
          }

          return acc
        }, [] as HarvestDate[])
        .map((h) => ({
          date: h.date,
          count: h.count,
          quantity: h.quantity,
          quality: h.quality / h.quantity,
          ripeness: h.ripeness / h.quantity,
          size: h.size / h.quantity,
          traits: h.traits,
          ids: h.ids,
        }))
    },
  },
  methods: {
    formatNumber: formatNumber,
    clickRow(h: HarvestDate) {
      // console.log(h)

      const i = this.expanded.findIndex((z: HarvestDate) => z.date === h.date)
      if (i >= 0) {
        this.$delete(this.expanded, i)
      } else {
        this.expanded.push(h as never)
      }
      // this.expanded = [h as never]

      // this.dialogIds = [h.plant.gardenId, h.plantId, h.id]

      // this.$router.push({ name: this.$route.name || 'error', params: Object.assign({}, this.$route.params, { harvestId: h.id }) })
    },
    closeDialog() {
      // this.dialogIds = undefined
      this.$router.push({
        name: this.$route.name || 'error',
        params: Object.assign({}, this.$route.params, { harvestId: undefined }),
      })
    },
    closeAddDialog() {
      // this.addDialogId = undefined
    },
  },
})
